import { BookOpen } from 'lucide-react';
import { Link } from 'react-router';
import { cn } from '../../lib/cn';

export function Logo({ className, size = 'md' }: { className?: string; size?: 'md' | 'lg' }) {
  return (
    <Link to="/" aria-label="Libellus, home" className={cn('flex items-center gap-2.5', className)}>
      <span
        aria-hidden
        className={cn(
          'flex items-center justify-center rounded-xl bg-accent text-accent-ink',
          size === 'lg' ? 'size-11 [&_svg]:size-6' : 'size-9 [&_svg]:size-5',
        )}
      >
        <BookOpen />
      </span>
      <span className={cn('heading', size === 'lg' ? 'text-title' : 'text-lead')}>Libellus</span>
    </Link>
  );
}
